import { render, staticRenderFns } from "./UpdateProfileInformationForm.vue?vue&type=template&id=613608d8&"
import script from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js&"
export * from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports